<div class="card border-0 shadow-sm pt-0 pb-1 mb-4">
    <div class="card-header fs-5 fw-medium">Employment Details</div>
    <div class="card-body position-relative">
        <dx-load-panel [visible]="isLoading" [showPane]="false" [position]="{ of: '.card-body' }"></dx-load-panel>
        @if(employmentData) {
            <div class="px-3 mb-2">
                <div class="row g-3">
                    <div class="col-md-6">
                        <employment-detail-row label="Status" [value]="employmentData.positionStatus | positionStatus" [valueClass]="getStatusBadgeClass(employmentData.positionStatus)"></employment-detail-row>
                        <employment-detail-row label="Position ID" [value]="employmentData.positionId"></employment-detail-row>
                        <employment-detail-row label="Payroll Company Code" [value]="employmentData.payrollCompanyCode" [upperCase]="true"></employment-detail-row>
                        <employment-detail-row label="Tax ID (SIN)" [value]="employmentData.taxId"></employment-detail-row>
                        <employment-detail-row label="Birth Date" [value]="employmentData.birthDate | date : 'longDate'"></employment-detail-row>
                        <employment-detail-row label="Age" [value]="employmentData.age"></employment-detail-row>
                    </div>
                    <div class="col-md-6">
                        <employment-detail-row label="Hire Date" [value]="employmentData.hireDate | date : 'longDate'"></employment-detail-row>
                        <employment-detail-row label="Years Worked" [value]="employmentData.yearsWorked"></employment-detail-row>
                        <employment-detail-row label="Job Title Description" [value]="employmentData.jobTitleDescription" [capitalCase]="true"></employment-detail-row>
                        <employment-detail-row label="Pay Class" [value]="employmentData.payClass" [capitalCase]="true" [upperCase]="true"></employment-detail-row>
                        <employment-detail-row label="Home Department Code" [value]="employmentData.homeDepartmentCode"></employment-detail-row>
                        <employment-detail-row label="Standard Hours" [value]="employmentData.standardHours"></employment-detail-row>
                    </div>
                </div>
                <div class="row g-3 mt-1">
                    <div class="col-md-4">
                        <label class="form-label">SAP Access</label>
                        <dx-select-box
                            [(value)]="employmentData.sapAccess"
                            [items]="yesNoOptions"
                            valueExpr="value"
                            displayExpr="text"
                            placeholder="Select..."
                            [showClearButton]="true"
                            stylingMode="filled"
                            (onValueChanged)="onFieldChange($event)"
                            [readOnly]="isReadOnly"
                        ></dx-select-box>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">DWA Access</label>
                        <dx-select-box
                            [(value)]="employmentData.dwaAccess"
                            [items]="yesNoOptions"
                            valueExpr="value"
                            displayExpr="text"
                            placeholder="Select..."
                            [showClearButton]="true"
                            stylingMode="filled"
                            (onValueChanged)="onFieldChange($event)"
                            [readOnly]="isReadOnly"
                        ></dx-select-box>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">NextView Access</label>
                        <dx-select-box
                            [(value)]="employmentData.nextViewAccess"
                            [items]="yesNoOptions"
                            valueExpr="value"
                            displayExpr="text"
                            placeholder="Select..."
                            [showClearButton]="true"
                            stylingMode="filled"
                            (onValueChanged)="onFieldChange($event)"
                            [readOnly]="isReadOnly"
                        ></dx-select-box>
                    </div>
                </div>
            </div>
        }
    </div>
</div>

